import { useState } from "react";
import PropTypes from "prop-types";
import Header from "../Header";
import Navbar from "../Navbar";
import Footer from "../Footer";
import background from "../../assets/video/hienleeone.mp4";
import { motion } from "framer-motion";
import { containerVariants } from "../../config/animations";
import { useTheme } from "../../context/ThemeContext";
import FpsCounter from "../../components/FpsCounter";


function DefaultLayout({ children }) {
  const { lowEndMode, showFps } = useTheme();
  const [videoReady, setVideoReady] = useState(false);

  return (
    <div className="min-h-dvh relative">
      {/* Video Background - locked to full viewport to prevent resizing */}
      {!lowEndMode && (
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          onCanPlay={() => setVideoReady(true)}
          style={{ width: "100vw", height: "100vh" }}
          className={`fixed inset-0 w-screen h-screen object-cover -z-20 pointer-events-none transition-opacity duration-1000 ${
            videoReady ? "opacity-100" : "opacity-0"
          }`}
        >
          <source src={background} type="video/mp4" />
        </video>
      )}

      {/* Overlay */}
      <div
        style={{ width: "100vw", height: "100vh" }}
        className="fixed inset-0 w-screen h-screen bg-black/5 dark:bg-black/60 -z-10 transition-colors duration-500"
      />

      {/* Nội dung (max-w-[1020px], p-2 sm:p-3, space-y-2.5 sm:space-y-3) */}
      <motion.div
        className="relative z-10 max-w-[1020px] mx-auto p-2 sm:p-3 space-y-2.5 sm:space-y-3"
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <Header />
        <Navbar />

        <div className="relative z-10 w-full min-h-0">
          {children}
        </div>

        <Footer />
      </motion.div>

      {/* FPS Counter */}
      {showFps && <FpsCounter />}
    </div>
  );
}

DefaultLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DefaultLayout;
